import { render, staticRenderFns } from "./CreateContactList.vue?vue&type=template&id=a65ff3a0&"
import script from "./CreateContactList.vue?vue&type=script&lang=js&"
export * from "./CreateContactList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports